import { distance, summarizeTrips, checkSummary, inspectionSummary } from './trips.js'

export async function createTripWorkbook(trips, drivers, vehicles, records, month) {
  const { default: ExcelJS } = await import('exceljs')
  const workbook = new ExcelJS.Workbook()
  workbook.creator = 'HAKOVAL ALCO LOG'
  const names = Object.fromEntries(drivers.map(d => [d.id, d.name]))
  const numbers = Object.fromEntries(vehicles.map(v => [v.id, v.number]))
  function sheet(name, headings, rows) {
    const ws = workbook.addWorksheet(name, { views: [{ state: 'frozen', ySplit: 1 }] })
    ws.addRow(headings); rows.forEach(row => ws.addRow(row))
    ws.getRow(1).font = { bold: true, color: { argb: 'FFFFFFFF' } }
    ws.getRow(1).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF1261B5' } }
    ws.columns.forEach((column, i) => { column.width = i === 0 ? 16 : 24 })
    ws.eachRow(row => { row.alignment = { vertical: 'top', wrapText: true } })
    ws.autoFilter = { from: { row: 1, column: 1 }, to: { row: rows.length + 1, column: headings.length } }
    ws.pageSetup = { paperSize: 9, orientation: 'landscape', fitToPage: true, fitToWidth: 1, fitToHeight: 0 }
    return ws
  }
  const daily = sheet('日報一覧', ['出発日','ドライバー','車両','出発日時','帰着日時','出発(km)','帰着(km)','走行距離(km)','状態','配送先・作業内容','異常・連絡事項','アルコール確認','車両点検','引継元記録','メーター修正理由'],
    trips.map(t => [t.date,names[t.driverId],numbers[t.vehicleId],t.startedAt.slice(0,16).replace('T',' '),t.endedAt?.slice(0,16).replace('T',' ') || '',t.startKm,t.endKm,distance(t),distance(t) === null ? '未完了' : '帰着済み',t.work,t.note,checkSummary(t,records),inspectionSummary(t,records),t.sourceId || '',t.correctionReason || '']))
  for (let row = 2; row <= trips.length + 1; row++) {
    const km = distance(trips[row - 2])
    if (km !== null) daily.getCell(`H${row}`).value = { formula: `ROUND(G${row}-F${row},1)`, result: km }
    for (const col of ['F','G','H']) daily.getCell(`${col}${row}`).numFmt = '0.0'
  }
  for (const [key,label,map] of [['vehicleId','車両別集計',numbers],['driverId','ドライバー別集計',names]]) {
    const rows = summarizeTrips(trips,key)
    sheet(label, ['対象月',label.replace('集計',''),'記録数','帰着未入力','走行距離合計(km)'], rows.map(r => [month,map[r.id] || r.id,r.count,r.pending,r.km]))
  }
  sheet('説明', ['項目','内容'], [['保存範囲','体験版：このブラウザの記録のみ。サンプルデータを含む場合があります。'],['対象月',month],['集計基準','出発日の月で集計。帰着未入力は距離に含めず、未完了件数として表示。'],['安全確認','日報の帰着済みは、アルコール確認や運転許可の完了を意味しません。'],['再測定','アルコールチェック回数によらず、1運行につき1回だけ距離集計。']])
  return workbook
}
export async function exportTripWorkbook(...args) {
  const workbook = await createTripWorkbook(...args)
  const buffer = await workbook.xlsx.writeBuffer()
  const url = URL.createObjectURL(new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }))
  const link = document.createElement('a'); link.href = url; link.download = `走行距離・日報_${args[4]}.xlsx`
  document.body.appendChild(link); link.click(); link.remove(); setTimeout(() => URL.revokeObjectURL(url), 60000)
}
